import { MessageCircle, ClipboardCheck, BadgeCheck } from "lucide-react";

export const STEPS = [
  {
    icon: MessageCircle,
    title: "Arayın veya WhatsApp'tan yazın",
    desc: "Arızayı kısaca anlatın, dilerseniz fotoğraf gönderin. Telefonu doğrudan işi yapacak usta açar, aracı ve çağrı merkezi yoktur.",
  },
  {
    icon: ClipboardCheck,
    title: "Net fiyat, net plan",
    desc: "Gerekirse yerinde keşif yaparız. İşe başlamadan ücreti ve yapılacakları konuşuruz; iş bitince sürpriz ek ücret çıkarmayız.",
  },
  {
    icon: BadgeCheck,
    title: "Temiz ve garantili iş",
    desc: "Kırma dökme yapmadan çalışır, iş bitince ortamı temiz bırakırız. Yaptığımız işçiliğin arkasında durur, garanti veririz.",
  },
];

export const FAQ = [
  {
    q: "Beylikdüzü'nde hangi mahallelere hizmet veriyorsunuz?",
    a: "Adnan Kahveci, Beykent, Cumhuriyet, Barış, Yakuplu, Ambarlı, Marmara, Gürpınar, Dereağzı, Kavaklı, Büyükşehir ve Sahil mahalleleri başta olmak üzere Beylikdüzü'nün tamamına hizmet veriyoruz.",
  },
  {
    q: "Fiyatı nasıl öğrenebilirim?",
    a: "Telefonla veya WhatsApp'tan arızayı anlatmanız yeterli. İşe başlamadan fiyatı net olarak konuşuruz; iş bitince sürpriz ek ücret çıkarmayız.",
  },
  {
    q: "Çalışma saatleriniz nedir?",
    a: "Hafta içi ve hafta sonu 08:00 – 23:00 arasında hizmet veriyoruz. Elektrik kesintisi gibi acil durumlarda 7/24 ulaşabilirsiniz.",
  },
  {
    q: "Aynı gün servis mümkün mü?",
    a: "Beylikdüzü içinde olduğumuz için çoğu arızaya aynı gün müdahale ediyoruz. Acil durumlarda önceliklendirme yapıyoruz.",
  },
];
